const NAME = 'fabric-los-retention';

export default {
    app: {
        name: NAME,
    },
    customElement: {
        name: NAME,
        attributes: {
            moduleName: 'component',
            params: 'params',
            hydrate: 'hydrate',
        },
        mountPoints: {
            root: 'data-render-root',
            state: 'data-render-state',
        },
    },
};

export const FORCE_HYDRATION_MFES = [
    'logged-out-toasts',
    'welcome-pop-up',
    'pnp-deposit-error-popup',
    'smartico-mini-game',
    'pay-and-play-callback',
];
